"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoMultiPointLocation = void 0;
require("reflect-metadata");
/**
 * Mongo native format, must be also indexed as 2dsphere to work
 */
class MongoMultiPointLocation {
    constructor(coordinates) {
        this.type = "MultiPoint";
        this.coordinates = coordinates;
    }
    type = "MultiPoint";
    /**
     * [ [ longitude, latitude ], [ longitude, latitude ] ]
     */
    coordinates;
}
exports.MongoMultiPointLocation = MongoMultiPointLocation;
//# sourceMappingURL=MongoMultiPointLocation.js.map